/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseActErrorCode = parseActErrorCode;
/**
 * 频道延时类型
 */
var ActDelayType = {
    NORMAL: 1, // 普通
    LOW_DELAY: 2 // 低延时
};

var ActErrorCode = {
    /**
    * 账户欠费（只限制低延时以外的资源）
    */
    BILL_NOT_PAID: 101,
    /**
    * 试用用户：超并发 (限制所有)
    */
    TRIAL_USER_CONCURRENT_ERROR: 102,
    /**
    * 其他用户：超并发（限制所有）
    */
    USER_CONCURRENT_ERROR: 103,
    /**
    * 频道消费达到上限（限制所有）
    */
    ACT_OVER_BUDGET: 104,
    /**
    * 观看时长达到上线（只限制低延时以外的资源）
    */
    WATCH_TIME_OVER_BUDGET: 105,
    /**
    * 用户不存在（单独出现，限制所有）
    */
    USER_NOT_EXIST: 106,
    /**
    * 拉流流量达到上限（只限制低延时以外资源）
    */
    DATA_FLOW_OVER_BUDGET: 107,
    /**
    * 低延时资源无（只限制低延时资源）
    */
    LOW_DELAY_SOURCE_RUN_OUT: 108
};

// 会阻止观看直播的错误码
var preventLiveCodes = [ActErrorCode.BILL_NOT_PAID, ActErrorCode.TRIAL_USER_CONCURRENT_ERROR, ActErrorCode.USER_CONCURRENT_ERROR, ActErrorCode.ACT_OVER_BUDGET, ActErrorCode.WATCH_TIME_OVER_BUDGET, ActErrorCode.USER_NOT_EXIST, ActErrorCode.DATA_FLOW_OVER_BUDGET];
// 会阻止观看回放的错误码
var preventTrailerCodes = [ActErrorCode.BILL_NOT_PAID, ActErrorCode.TRIAL_USER_CONCURRENT_ERROR, ActErrorCode.USER_CONCURRENT_ERROR, ActErrorCode.ACT_OVER_BUDGET, ActErrorCode.WATCH_TIME_OVER_BUDGET, ActErrorCode.USER_NOT_EXIST, ActErrorCode.DATA_FLOW_OVER_BUDGET];
// 会阻止观看低延时直播的错误码
var preventLowDelayLiveCodes = [ActErrorCode.TRIAL_USER_CONCURRENT_ERROR, ActErrorCode.USER_CONCURRENT_ERROR, ActErrorCode.ACT_OVER_BUDGET, ActErrorCode.USER_NOT_EXIST, ActErrorCode.LOW_DELAY_SOURCE_RUN_OUT];

function parseActErrorCode(errcodeStr, actDelayType) {
    var codes = errcodeStr.split(',').filter(function (v) {
        return !!v;
    }).map(function (v) {
        return +v;
    });
    // 普通直播
    var normalLive = false;
    // 低延时直播
    var lowDelayLive = false;
    var trailer = false;

    // 有错误码
    if (codes.length) {
        codes.forEach(function (code) {
            if (preventLiveCodes.includes(code)) {
                normalLive = true;
            }
            if (preventTrailerCodes.includes(code)) {
                trailer = true;
            }
            if (preventLowDelayLiveCodes.includes(code)) {
                lowDelayLive = true;
            }
        });
    }

    // 根据频道类型选择live错误码
    var live = false;
    switch (actDelayType) {
        case ActDelayType.LOW_DELAY:
            live = lowDelayLive;
            break;
        case ActDelayType.NORMAL:
        default:
            live = normalLive;
    }

    return {
        hasLiveErrcode: live,
        hasTrailerErrcode: trailer
    };
}



/*****************
 ** WEBPACK FOOTER
 ** ./application/helper/actErrcode.js
 ** module id = 144
 ** module chunks = 1
 **/